import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import api from '../services/api';

export default function Signup() {
  const [form, setForm] = useState({ email: '', password: '', display_name: '' });
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const submit = async e => {
    e.preventDefault();
    try {
      const { data } = await api.post('/auth/signup', form);
      localStorage.setItem('token', data.token);
      localStorage.setItem('user', JSON.stringify(data.user));
      navigate('/');
    } catch (err) { setError(err.response?.data?.error || 'Signup failed'); }
  };

  const set = key => e => setForm({ ...form, [key]: e.target.value });

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', background: '#6366f1' }}>
      <form onSubmit={submit} style={{ background: '#fff', padding: 40, borderRadius: 12, width: 380, boxShadow: '0 8px 32px rgba(0,0,0,.15)' }}>
        <h1 style={{ marginBottom: 8, fontSize: 28 }}>🔲 Sign Up</h1>
        <p style={{ color: '#666', marginBottom: 24 }}>Create your account</p>
        {error && <p style={{ color: 'red', marginBottom: 12 }}>{error}</p>}
        <input value={form.display_name} onChange={set('display_name')} placeholder="Display Name"
          style={{ width: '100%', padding: 12, marginBottom: 12, border: '1px solid #ddd', borderRadius: 8, fontSize: 14 }} />
        <input value={form.email} onChange={set('email')} placeholder="Email" type="email" required
          style={{ width: '100%', padding: 12, marginBottom: 12, border: '1px solid #ddd', borderRadius: 8, fontSize: 14 }} />
        <input value={form.password} onChange={set('password')} placeholder="Password" type="password" required minLength={6}
          style={{ width: '100%', padding: 12, marginBottom: 20, border: '1px solid #ddd', borderRadius: 8, fontSize: 14 }} />
        <button type="submit" style={{ width: '100%', padding: 12, background: '#6366f1', color: '#fff', border: 'none', borderRadius: 8, fontSize: 16, cursor: 'pointer', fontWeight: 600 }}>Create Account</button>
        <p style={{ textAlign: 'center', marginTop: 16, color: '#666' }}>Have an account? <Link to="/login" style={{ color: '#6366f1' }}>Sign in</Link></p>
      </form>
    </div>
  );
}
